<template>
  <draggable :disabled="!edit"   :class="{'edit': edit }"  class="dragArea" @end="onEnd" tag="ul" :list="data" :group="{ name: 'g1' }">
    <li @drop="onDropHandler" @dragenter="onDragEnter" @dragleave="onDragLeave" :id="dirItem.id"   @dragleave.prevent  @dragenter.prevent @dragover.prevent class="directory-item" v-for="dirItem in data" :key="dirItem.id">
      <div :class="{'active': !edit && activeDirId && dirItem.id == activeDirId , 'dash-boarder': dragOverId.id == dirItem.id}"  @click="onClickDir(dirItem, $event)" class="item-wrapper">
        <i v-if="dirItem.children.length > 0" @click="onExpandCollapse(dirItem)" :class="{'fa-folder-plus': !dirItem.expand, 'fa-folder-open': dirItem.expand }" class="fal"></i>
        <i v-if="dirItem.children.length === 0" class="fal fa-folder"></i>
        <div  class="directory-name">
          <span v-if="!edit">{{dirItem.name}}</span>
          <input v-if="edit" type="text" v-model="dirItem.name"  class="form-control" />
        </div>
        <div v-if="!edit" class="right-element">
          <span v-if="statistic[dirItem.id]">
             {{statistic[dirItem.id].benefit}} /  {{statistic[dirItem.id].revenue}}
          </span>
        </div>
        <div class="right-element"  v-if="edit">
          <a href="javascript:" @click="onClickDelete(dirItem, $event)">
            <i class="fal fa-trash"></i>
          </a>
        </div>
      </div>
      <transition name="opacity">
        <directory-list :edit="edit"
                        :statistic="statistic"
                        :active-dir-id="activeDirId"
                        :drag-over-id="dragOverId"
                        @on-edit="onEdit"
                        @on-delete="onDelete"
                        @on-click="onClick"
                        @on-change="onChange"
                        @on-collapse="onCollapse"
                        @on-drop="onDrop"
                        v-show="dirItem.expand"
                        :data="dirItem.children">
        </directory-list>
      </transition>
    </li>
  </draggable>

</template>

<script>

import draggable from 'vuedraggable';

let timeout;

export default {
  name: 'DirectoryList',
  components: {
    draggable,
  },
  props: {
    edit: Boolean,
    data: Array,
    activeDirId: [String, Number],
    statistic: [Array, Object],
    dragOverId: Object,
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    onDragLeave($event) {
      if (this.edit) {
        return;
      }
      const vm = this;
      // eslint-disable-next-line
      if (vm.dragOverId.id == $event.currentTarget.id) {
        timeout = setTimeout(() => {
          vm.dragOverId.id = null;
        }, 500);
      }
    },
    onDragEnter($event) {
      if (this.edit) {
        return;
      }
      const vm = this;
      $event.stopPropagation();

      const targetId = $event.currentTarget.id;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        vm.dragOverId.id = targetId;
      }, 5);
    },

    onDrop(data) {
      if (this.edit) {
        return;
      }
      this.$emit('on-drop', data);
    },
    onDropHandler($event) {
      const invoiceId = $event.dataTransfer.getData('INVOICE_ID');
      if (this.edit || !invoiceId) {
        return;
      }
      const vm = this;
      $event.preventDefault();
      $event.stopPropagation();
      this.$emit('on-drop', {
        invoiceId,
        directoryId: $event.currentTarget.id,
      });

      timeout = setTimeout(() => {
        vm.dragOverId.id = null;
      }, 250);
    },
    onEnd() {
      this.$emit('on-change', this.data);
    },
    onChange() {
      this.$emit('on-change', this.data);
    },
    onClickEdit(dirItem) {
      this.$emit('on-edit', dirItem);
    },
    onEdit(dirItem) {
      this.$emit('on-edit', dirItem);
    },
    onClick(data) {
      this.$emit('on-click', data);
    },
    onClickDir(dirItem, $event) {
      // if (!$event.target.className.includes('fa-chevron')) {}
      this.$emit('on-click', {
        $event,
        dirItem,
      });
    },
    onClickDelete(dirItem) {
      this.$emit('on-delete', dirItem);
    },
    onDelete(dirItem) {
      this.$emit('on-delete', dirItem);
    },
    onExpandCollapse(dirItem) {
      this.$emit('on-collapse', dirItem, !dirItem.expand);
    },
    onCollapse(dirItem) {
      this.$emit('on-collapse', dirItem, !dirItem.expand);
    },
  },
};
</script>
<style scoped>
.dash-boarder {
  border: 2px dashed #7f7d7d;
}
</style>




// WEBPACK FOOTER //
// src/portal-components/directory-list/directory-tree.vue